import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {State} from '../interfaces'
import common from '../slices/common'
import orderSheetCoupon from '../slices/orderSheetCoupon'

const createRootReducer = (): Reducer<State> =>
    combineReducers({
        common,
        orderSheetCoupon,
        router: routerReducer,
    })

export default createRootReducer
